<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Link } from '@inertiajs/vue3'
import logo from '@/../images/logo.jpg'
import Header from '@pages/home/components/Header.vue'
import Footer from '@pages/home/components/Footer.vue'

// Navbar behavior
const isScrolled = ref(false)
const mobileMenuOpen = ref(false)

const toggleMobileMenu = () => (mobileMenuOpen.value = !mobileMenuOpen.value)
const handleScroll = () => (isScrolled.value = window.scrollY > 10)

onMounted(() => window.addEventListener('scroll', handleScroll))
onBeforeUnmount(() => window.removeEventListener('scroll', handleScroll))

// Programs Data
const programs = [
  {
    title: 'Qur’anic Memorization Program',
    description:
      'Dedicated to helping students memorize and understand the Qur’an with proper tajweed and guidance from qualified scholars.',
    icon: '📖',
  },
  {
    title: 'Arabic Language Studies',
    description:
      'Equips learners with the ability to read, write, and speak Arabic fluently while understanding classical and modern texts.',
    icon: '🗣️',
  },
  {
    title: 'Islamic Jurisprudence (Fiqh)',
    description:
      'Focuses on the principles of Islamic law, teaching students how rulings are derived and applied in daily life.',
    icon: '⚖️',
  },
  {
    title: 'Hadith and Sunnah Studies',
    description:
      'Explores the sayings and actions of Prophet Muhammad (SAW) and their relevance in guiding moral and social conduct.',
    icon: '🌙',
  },
  {
    title: 'Contemporary Islamic Thought',
    description:
      'Bridges traditional Islamic knowledge with modern challenges to nurture scholars who can engage with today’s world.',
    icon: '💡',
  },
  {
    title: 'Leadership & Da’wah Training',
    description:
      'Empowers students with communication and leadership skills to effectively spread Islamic teachings in their communities.',
    icon: '🕋',
  },
]
</script>

<template>
  <div class="relative">
    <!-- ======= Header / Navbar ======= -->
    <Header />

    <!-- ======= Hero Section ======= -->
    <section class="bg-primary-100 py-24 text-center mt-16">
      <h2 class="text-4xl font-bold text-primary-700 mb-4">Our Programs</h2>
      <p class="max-w-2xl mx-auto text-gray-600 text-lg">
        Discover our comprehensive educational programs designed to nurture faith, knowledge, and leadership.
      </p>
    </section>

    <!-- ======= Programs Section ======= -->
    <section class="max-w-7xl mx-auto px-6 py-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
      <div
        v-for="(program, index) in programs"
        :key="index"
        class="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 text-center"
      >
        <div class="text-5xl mb-4">{{ program.icon }}</div>
        <h3 class="text-2xl font-semibold text-primary-700 mb-3">{{ program.title }}</h3>
        <p class="text-gray-600 leading-relaxed">{{ program.description }}</p>
      </div>
    </section>
    <Footer />
  </div>
</template>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.4s ease;
}
.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
